import {useSelector} from 'react-redux'
import {getOfferContext} from 'middleware/analytics/selectors'
import {getAccommodationPageHotelId} from 'modules/accommodation/selectors'

import {useDispatchTeamEvent} from '@vio/core/src/analytics/hooks/useDispatchTeamEvent'
import {trackEvent} from '@vio/core/src/analytics/modules/actions'
import {
  Action,
  AnalyticsContext,
  Category,
  Entity,
  Page,
  Team
} from '@vio/core/src/analytics/types/Events'
import {ComponentSource} from '@vio/shared/src/dealFreeze/types'

interface Args {
  offerId?: string
  sourceComponent?: string
}

export const useDealFreezeTagTracking = ({offerId, sourceComponent}: Args) => {
  const hotelId = useSelector(getAccommodationPageHotelId)
  const dispatchTeamEvent = useDispatchTeamEvent()
  const offerContext = useSelector(state =>
    offerId ? getOfferContext(state, hotelId, offerId, sourceComponent) : null
  )

  const track = (category: Category, action: Action) =>
    dispatchTeamEvent(
      trackEvent({
        category,
        entity: Entity.DealFreezeTag,
        action,
        analyticsContext: {
          ...(offerContext && {
            [AnalyticsContext.OfferContext]: offerContext
          })
        },
        page: Page.Accommodation,
        component: ComponentSource.HotelViewTopOffers,
        team: Team.Select
      })
    )

  return {
    onDisplayed: () => track(Category.System, Action.Displayed),
    onClicked: () => track(Category.User, Action.Clicked),
    onTooltipOpen: () => track(Category.User, Action.MouseOvered)
  }
}
